import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tablePlayersReportView.
 * @extends JetView
 */
export default class tablePlayersReportView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Type of view
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            height: screen.width < 820 ? 450 : 0, // Conditional height based on screen width
            columns: [
                // Column definitions for the datatable
                {
                    id: 'Login',
                    header: _('Usuario (Correo electrónico)'), // Localized header
                    width: 100,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'ClientId',
                    header: _('ID Cliente'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'CurrentBalance',
                    header: _('Dinero real'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'AcceptanceDateLocal',
                    header: _('Aceptar'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'ExpirationDateLocal',
                    header: _('Fecha Expiración'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'SumBonusBalance',
                    header: _('Balance Bonos'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'TotalBalance',
                    header: _('Total Balance'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'SportBetAmount',
                    header: _('Sport Real Money Bet'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'CasinoBetAmount',
                    header: _('Casino Real Money Bet'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'RealMoneyBetAmount',
                    header: _('Real Money Bet'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'SportBonusBetAmount',
                    header: _('Sport Bonus Money Bet'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'CasinoBonusBetAmount',
                    header: _('Casino Bonus Money Bet'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'BonusBetAmount',
                    header: _('Bonus Money Bet'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'SportTotalBetAmount',
                    header: _('Sport Total Bet'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'CasinoTotalBetAmount',
                    header: _('Casino Total Bet'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'TotalBetAmount',
                    header: _('Total Bet'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'SportRealMoneyWonAmount',
                    header: _('Sport Real Money Won'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'CasinoRealMoneyWonAmount',
                    header: _('Casino Real Money Won'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'RealMoneyWonAmount',
                    header: _('Real Money Won'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'SportBonusWinAmount',
                    header: _('Sport Bonus Won'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'CasinoBonusWinAmount',
                    header: _('Casino Bonus Won'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'BonusWonAmount',
                    header: _('Bonus Won'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'SportBonusAmount',
                    header: _('Sport Converted Bonus'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'CasinoBonusAmount',
                    header: _('Casino Converted Bonus'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'ConvertedBonusAmount',
                    header: _('Converted Bonus'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'PlayerType',
                    header: _('Tipo de Jugadores'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'SportNetProfit',
                    header: _('Sport Net Profit'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'CasinoNetProfit',
                    header: _('Casino Net Profit'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'NetProfit',
                    header: _('Net Profit'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'SportNetProfitLessBonus',
                    header: _('Sport Net'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'CasinoNetProfitLessBonus',
                    header: _('Casino Net Profit'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'NetProfitLessBonus',
                    header: _('Net Profit'),
                    width: 150,
                    sort: 'int',
                },
            ],
            ready: function () {
                // Function executed when the datatable is ready
                if (!this.count()) {
                    // Check if there are no rows
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        // Show overlay message
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // Localized no data message
                            '</div>',
                    );
                }
            },
            footer: true, // Enable footer
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'es/Report/GetClientBonusReport', // Data source URL
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            // Event listener for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object and non-empty values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Append start date
                        string1 = string1 + '&dateTo=' + date[1]; // Append end date
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object type filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format start date
                                        'dateTo=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append formatted start date
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format end date
                                            'dateFrom=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append formatted end date
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.load(
                // Load data into the grid
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1, // Append query string
            );
        });
        grid.attachEvent('onAfterSelect', (obj) => {
            // Event listener for row selection
            this.app.callEvent('user:id', [obj.id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (id) => {
            // Event listener for player selection
            grid.load(
                // Load data for selected player
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Append player ID to query
            );
        });
        $$(function () {
            // Function to make columns resizable
            $$('webix_layout_space').resizableColumns({
                // Enable resizable columns
                store: window.store, // Store for column resizing
            });
        });
    }
}

// FILE DOCUMENTED
